export default function getAchievements(array) {
  const achievements = []
  if (array.length === 25) achievements.push("巡演全勤")
  if (some([1,2,3], array) && some([4,5], array) && some([6,7], array) && some([8,9], array)
    && some([10,11], array) && some([12,13], array) && some([14,15], array) && some([16,17], array)
    && some([18,19], array) && some([20,21], array) && some([22,23], array) && some([24,25], array))
    achievements.push("城市全勤")
  if (every([1,2,3,10,11,20,21], array))
    achievements.push("大湾区全勤")
  if (some([1,2,3], array) && some([10,11], array) && some([20,21], array))
    achievements.push("大湾区城市全勤")
  if (every([4,5,22,23,24,25], array))
    achievements.push("江浙沪全勤")
  if (some([4,5], array) && some([22,23], array) && some([24,25], array))
    achievements.push("江浙沪城市全勤")
  if (every([6,7,18,19], array))
    achievements.push("川渝全勤")
  if (some([6,7], array) && some([18,19], array))
    achievements.push("川渝城市全勤")
  if (some([11,14,17,19,23,25], array))
    achievements.push("见过地板动作")
  if (every([11,14,17,19,23,25], array))
    achievements.push("地板动作全搜集")
  if (every([1,4,5,7,8,13,14,21], array))
    achievements.push("是我的海全搜集")
  if (!some([1,4,5,7,8,13,14,21], array) && array.length > 0)
    achievements.push("是我的海完全没听过")
  if (some([18,20], array) && some([5,14,16,21,24], array) && some([1,17,20,21,25], array) && some([2,11,21], array)
    && some([3,20], array) && some([10,18], array) && some([11,19], array) && some([19], array)
    && some([1,3,4,6,14,17], array))
    achievements.push("夏专歌曲全部听过")
  if (some([2,3,4,7,8,9,10,11,18,19,21,22,23,24], array))
    achievements.push("听过只唱了一次的歌")
  if (some([6,7,12,13,22,23,24,25], array))
    achievements.push("不一样的四季纸花")
  if (some([7,13,21,25], array))
    achievements.push("曾和吴妈妈同场观演")
  if (every([7,13,21,25], array))
    achievements.push("吴妈妈场次全勤")
  if (some([7,22,23], array))
    achievements.push("在点歌听到一刻单曲")
  if (some([6,7,10,11,14,15,16,17,22,23,24,25], array))
    achievements.push("听过暂未发表一刻单曲")
  if (some([1,2,3,7,22], array) && some([4,5,7], array) && some([6,7], array) && some([8,9,22], array)
    && some([10,11], array) && some([12,13,23], array) && some([14,15], array) && some([16,17], array)
    && some([18,19,22], array) && some([20,21], array) && some([22,23], array) && some([24,25], array))
    achievements.push("一刻单曲全部听过")
  if (some([6,7,13,18], array))
    achievements.push("明星点歌")
  return achievements
}

function every(a, b) {
  return a.every(x => b.includes(x))
}

function some(a, b) {
  return a.some(x => b.includes(x))
}
